import { createContext, useContext } from "react";
import { useLocation, useParams } from "react-router-dom";

export interface IdAndStateContextType {
  id: string | undefined;
  state: {
    password: string;
  };
}

const IdAndStateContext = createContext<IdAndStateContextType | undefined>(undefined);

export const useIdAndStateContext = () => {
  const context = useContext(IdAndStateContext);
  if (!context) {
    throw new Error('useIdAndStateContext must be used within an IdAndStateProvider');
  }
  return context;
};

export const IdAndStateProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { id } = useParams<{ id: string }>();
  const location = useLocation();
  const state = location.state;

  return (
    <IdAndStateContext.Provider value={{ id, state }}>
      {children}
    </IdAndStateContext.Provider>
  );
};
